var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcThumbsUp = function SvgIcThumbsUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7A7A88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.163 4.8h-.8a1 1 0 0 0-1 1v6.865a1 1 0 0 0 1 1h.8a1 1 0 0 0 1-1V5.8a1 1 0 0 0-1-1M5.163 6.35v5.314a2 2 0 0 0 2 2h4.582a1.67 1.67 0 0 0 1.608-1.228l1.305-4.792A1.666 1.666 0 0 0 13.05 5.54h-2.73V3a1.334 1.334 0 0 0-1.333-1.333h-.024a1.33 1.33 0 0 0-1.113.6z"
  })));
};
export default SvgIcThumbsUp;